export default function mod(n, x) {
    return ((n % x) + x) % x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/src/lib/utils/mod.js
// module id = 222
// module chunks = 0